import api from "@/lib/api";
import { resourcesQuery, servicesQuery } from "@/hooks/useCatalog";

// Avvio della dashboard: tutto cio' che NON dipende dal risultato di /auth/me
// parte subito, in parallelo a /auth/me, invece di aspettarlo (prima: /auth/me
// -> poi il file del layout -> poi il file della pagina -> poi i dati).
// Un utente non autenticato che apre /dashboard riceve qualche 401 in piu'
// (ignorati) e viene comunque rimandato alla home dal ProtectedRoute.

const MAX_AGE_MS = 30_000;
let locationsPrefetch = null; // { promise, at }

export function prefetchLocations() {
  const promise = api.get("/locations");
  promise.catch(() => {}); // l'esito vero lo vede chi lo consuma
  locationsPrefetch = { promise, at: Date.now() };
}

// Consuma (una volta sola) la richiesta anticipata delle sedi, se recente.
export function takePrefetchedLocations() {
  const pre = locationsPrefetch;
  locationsPrefetch = null;
  return pre && Date.now() - pre.at < MAX_AGE_MS ? pre.promise : null;
}

// `route`: scheda di avvio calcolata da App.js (pagine da scaricare e se la
// pagina usa il catalogo condiviso risorse/servizi).
export function startDashboardPrefetch(queryClient, route) {
  if (!route) return;
  route.pages.forEach((page) => page.preload?.());
  prefetchLocations();
  if (route.catalog) {
    queryClient.prefetchQuery(resourcesQuery);
    queryClient.prefetchQuery(servicesQuery);
  }
}

// Panoramica: la finestra di prenotazioni dipende dal fuso dell'attivita', noto
// solo dopo /auth/me. Appena e' noto la richiesta parte, in parallelo al
// download della pagina (prima partiva dopo il suo rendering).
let overviewPrefetch = null; // { key, promise, at }

export function prefetchOverviewBookings(params) {
  const promise = api.get("/bookings", { params });
  promise.catch(() => {});
  overviewPrefetch = { key: JSON.stringify(params), promise, at: Date.now() };
}

// Consuma (una volta sola) la risposta anticipata, solo se i parametri coincidono e e' recente.
export function takePrefetchedOverviewBookings(params) {
  const pre = overviewPrefetch;
  overviewPrefetch = null;
  return pre && pre.key === JSON.stringify(params) && Date.now() - pre.at < MAX_AGE_MS ? pre.promise : null;
}
